<template lang="pug">
  header
    .header-top
      .wrap.container.mx-auto
        .logo
          component(:is="logoWrap" v-bind="logoWrapProps")
            img(v-if="logo && logo.id", :src="image.src", alt="NEW-GOL", rel="noopener")
        .menu-wrap
          .top-menu
            Menu#top-menu(k="top-menu", :max-depth="1")
            ShoppingCart.text-white
            button.hamburger.hamburger--3dy(type="button", :class="{ 'is-active': sidebar }", @click="toggleSidebar")
              span.hamburger-box
                span.hamburger-inner
          .cms-menu
            Menu#cms-menu(k="cms-menu", :max-depth="3")
    .header-bottom
      .wrap.container.mx-auto
        .product-menu
          Menu#product-menu(k="product-menu", :max-depth="3")

    .sticky-social
      ul
        li(v-if="Object.keys(member).length === 0")
          router-link(to="/haendler-login" title="Händler Login")  
            span 
              font-awesome-icon(icon="shopping-cart")
        li(v-else title="Warenkorb")
          span
            ShoppingCart(:force="true" :sidebar="true")
        li
          a(href="https://www.facebook.com/NEWGOLSulzbach" title="NEW-GOL Facebook" target="_blank" rel="noopener")
            span 
              font-awesome-icon(:icon="{prefix: 'fab', iconName: 'facebook-f'}")
        li
          a(href="https://instagram.com/" target="_blank" title="NEW-GOL Instagram" rel="noopener")
            span 
              font-awesome-icon(:icon="['fab', 'instagram']")
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import { trim } from '@/helpers';

import Menu from '@/components/Menu.vue';
import ShoppingCart from '@/extensions/shop/components/ShoppingCart.vue';

export default {
    name: 'Header',
    data: () => ({
        lastScroll: 0,
        stickyHeaderClass: ''
    }),
    components: {
        Menu,
        ShoppingCart
    },
    computed: {
        showShopMenu() {
            let result = false;
            const pageView = this.view || undefined;
            if (
                pageView === 'Products' ||
                pageView === 'Checkout' ||
                pageView === 'DownloadPage' ||
                pageView === 'Search'
            )
                result = true;
            return result;
        },

        logoWrap() {
            let tag = 'div';
            if (this.$route.path !== '/') {
                tag = 'a';
            }
            return tag;
        },
        logoWrapProps() {
            let props = {};
            if (this.$route.path !== '/') {
                props = { href: '/' };
            }
            return props;
        },
        image() {
            const storageRoute = trim(
                `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
                '/'
            );

            const fit = 'fit&w=250';

            let width = this.logo.width;
            let height = this.logo.height;

            return {
                src: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}`,
                error: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=blur`,
                width,
                height
            };
        },
        ...mapGetters({
            logo: 'logo',
            menus: 'menus',
            sidebar: 'sidebar',
            view: 'view',
            member: 'auth/member'
        })
    },
    methods: {
        toggleSidebar() {
            this.updateSidebarVisibility(!this.sidebar);
        },
        toggleNavClass() {
            if (this.active == false) {
                return 'nav';
            } else {
                return 'sticky-nav';
            }
        },
        updateStickyHeader() {
            const currentScroll = window.pageYOffset;

            const scrollUp = 'scroll-up';
            const scrollDown = 'scroll-down';

            if (currentScroll > this.lastScroll && this.stickyHeaderClass !== scrollDown) {
                this.stickyHeaderClass = scrollDown;
            } else if (currentScroll < this.lastScroll && this.stickyHeaderClass !== scrollUp) {
                this.stickyHeaderClass = scrollUp;
            }

            this.lastScroll = currentScroll;
        },
        ...mapMutations({
            updateSidebarVisibility: 'updateSidebarVisibility'
        })
    },
    mounted() {
        window.addEventListener('scroll', this.updateStickyHeader);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.updateStickyHeader);
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

header
  .header-top
    background-color: $color-primary
    @screen sm
      @apply mb-8
    @screen lg
      @apply mb-0
    .wrap
      @apply flex
      .logo
        @apply flex-shrink-0
        width: 150px
        img
          background-color: $color-secondary
          width: 80px
          height: auto
          box-shadow: 3px 2px 11px -2px rgba(0,0,0,0.5)
          @screen sm
            @apply absolute
          @screen lg
            @apply absolute
            width: 150px
            height: 174px
      .menu-wrap
        @apply w-full flex flex-wrap flex-col
        .top-menu
          @apply text-right flex justify-end
          min-height: 56px
          #top-menu
            @apply w-full hidden
            @screen lg
              @apply inline-block
            ::v-deep ul
              & > li
                @apply hidden
                @screen lg
                  @apply inline-block my-4
              & > li
                &.active .tree-item > a
                  text-shadow: -.25px -.25px 0 #fff, .25px .25px #fff
                &:last-child
                  .tree-item > a
                    @apply pr-0
                .tree-item > a
                  &::before
                    font-weight: 700
                  @apply text-white px-3 transition-colors duration-200 ease-in-out
                  text-shadow: -.25px -.25px 0 transparent, .25px .25px transparent
                  &:hover
                    color: $color-hover-header-menu
                    text-shadow: -.25px -.25px 0 #fff, .25px .25px #fff
          @media screen and(max-width: 1024px)
            @apply w-full
            #top-menu
              @apply w-full
              ::v-deep ul
                & > li
                  &:first-child
                    @apply inline float-right
                    width: calc(100% - 96px)
                    @media screen and(max-width: 640px)
                      @apply w-full pl-4
          @media screen and(max-width: 460px)
            ::v-deep .cart-summary .price
              @apply hidden

          .hamburger
            @apply p-0 ml-6
            @media screen and(max-width: 460px)
              @apply ml-4
            line-height: 32px
            @screen lg
              @apply hidden
            .hamburger-box
              @apply flex
              height: 32px
              .hamburger-inner,
              .hamburger-inner::before,
              .hamburger-inner::after
                @apply bg-white
                height: 3px
        .cms-menu
          @apply ml-6 hidden
          @screen lg
            @apply flex
          #cms-menu ::v-deep
            > ul.tree-menu > li.has-children > .tree-item > a > .sub-right
                @apply hidden
            ul
              & > li
                @apply inline-block my-4 uppercase
                &.active > .tree-item > a
                  @apply text-white
                  text-shadow: -.25px -.25px 0 #fff, .25px .25px #fff
                .tree-item > a
                  @apply text-white px-3 transition-colors duration-200 ease-in-out
                  text-shadow: -.25px -.25px 0 transparent, .25px .25px transparent
                  &:hover
                    text-shadow: -.25px -.25px 0 #fff, .25px .25px #fff
                ul
                    @apply shadow-lg absolute mt-4
                    z-index: 110
                    width: 250px
                    li
                      @apply m-0 block w-full relative
                      & > .tree-item a
                        @apply w-full font-medium tracking-normal text-white block max-w-md p-0 m-0
                        padding: 0.7rem
                        background-color: lighten($color-primary, 10%)
                        font-size: 15px
                        line-height: 1.6em
                        @screen lg
                          line-height: 1em
                        .svg-inline--fa
                          margin-left: -2px
                          margin-right: 5px
                        .sub-right
                          @apply float-right
                          margin-top: 1px

                        &:hover
                          @apply no-underline
                          color: $color-primary !important
                          background-color: #fff
                ul ul
                  @apply absolute mt-0 top-0
                  left: 100% !important
                  margin-left: 0px
                  li
                    & > .tree-item a
                      background-color: lighten($color-primary, 15%) !important

  .header-bottom
      #product-menu
          @apply hidden
          @screen lg
            @apply flex justify-end
          &::v-deep
            > ul.tree-menu > li.has-children > .tree-item > a > .sub-right
              @apply hidden
            > ul.tree-menu
              @apply pl-5
            ul
              @apply flex items-center justify-start flex-wrap
              width: 834px
              min-height: 60px
              @screen lg
                width: 834px
              @screen xl
                width: 990px
              &.tree-menu
                & > li
                  @apply relative transition duration-300 ease-in
                  .tree-item > a
                    @apply px-4 py-1 uppercase leading-normal font-semibold transition duration-200 ease-in-out text-base
                    color: $color-primary
                    @screen xl
                      //@apply text-xl
                    &:hover
                      color: $color-base-text
                      background-color: $color-primary
                  &.active .tree-item > a,
                  &.hover .tree-item > a
                    @apply text-white
                    background-color: $color-primary
                  ul
                    @apply shadow-lg z-50
                    width: 250px
                    margin-top: -10px
                    li
                      @apply relative
                      & > .tree-item a
                        @apply font-medium tracking-normal text-white block max-w-md m-0
                        padding: 0.7rem
                        background: $color-primary
                        font-size: 15px
                        line-height: 1.6em
                        @screen lg
                          line-height: 1em
                        .svg-inline--fa
                          margin-left: -2px
                          margin-right: 5px
                        .sub-right
                          @apply float-right
                          margin-top: 1px

                        &:hover
                          @apply no-underline
                          color: $color-primary !important
                          background-color: #fff !important
                      &.active > .tree-item a
                        font-weight: 800
                        //background-color: rgba($color-base-text, 80%)
            & > ul
              z-index: 100
              &.tree-menu
                & > li
                  @apply flex
                  //flex: 0 0 100%
                  &:last-child
                    flex: 1
                    .tree-item
                      @apply w-full
                  & ul
                    &.tree-menu
                      @apply absolute z-50 inline-block left-0 shadow-sm
                      top: 26px
                      margin-top: 0
                      min-width: 250px

                ul ul
                  @apply absolute top-0
                  min-width: 250px
                  left: 100% !important
                  margin-left: 0px
                  top: 0 !important
                  li
                      & > .tree-item a
                        background-color: lighten($color-primary, 10%) !important
  .sticky-social
    @apply hidden
    @screen lg
      @apply block fixed shadow-md
      top: 30%
      z-index: 1000
      right: -23px
      li
        background-color: $cc-green
        border-bottom: 1px solid #fff
        transition: transform 100ms
        &:hover
          transform: translate(-15px, 0)
        &:last-child
          border: 0
        .shopping-cart::v-deep
          line-height: 52px
          .icon
            width: inherit !important
            height: inherit  !important
          .price
            @apply hidden

        span
          @apply inline-block text-center text-white
          padding-right: 20px
          line-height: 52px
          width: 70px
          font-size: 16px
</style>
